import { Variants } from "framer-motion";

export const motionDefaultPresence: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring",
            stiffness: 300,
            damping: 30,
            delay: 0.2
        }
    },
    exit: {
        opacity: 0,
        transition: { duration: 0.2 }
    }
};

export const MOBILE_BREAKPOINT = 768; // Standard breakpoint for mobile devices

export const COOKIE_NAME_AUTH_TOKEN = "auth_token";
export const COOKIE_NAME_LOCALE = "locale";
export const COOKIE_NAME_REFERRAL_CODE = "refcode";

export const TUTOR_AVATAR_ORIGINAL_SIZE = {
    width: 384,
    height: 384
};

export const countryCodeToEmojiFlag = {
    "LT": "🇱🇹",
    "LV": "🇱🇻",
    "EE": "🇪🇪",
    "RU": "🇷🇺",
    "US": "🇺🇸",
    "GB": "🇬🇧",
    "DE": "🇩🇪",
    "FR": "🇫🇷",
    "ES": "🇪🇸",
    "IT": "🇮🇹",
    "NL": "🇳🇱",
    "SE": "🇸🇪",
    "NO": "🇳🇴",
    "DK": "🇩🇰",
    "FI": "🇫🇮",
    "PL": "🇵🇱",
    "CZ": "🇨🇿",
    "SK": "🇸🇰",
    "SI": "🇸🇮",
    "HR": "🇭🇷",
    "BA": "🇧🇦",
    "ME": "🇲🇪",
    "AL": "🇦🇱",
    "MK": "🇲🇰",
    "GR": "🇬🇷",
  };


export const PROBABILITY_OF_ONE_UP_ON_QUIZ_CORRECT_ANSWER = 0.52;

export const RouteNames = {
    dashboard: '/dashboard',
    contacts: '/contacts',
    learningFeed: '/learning-feed',
    profile: '/profile',
    practice: '/practice',
    exam: '/exam',
    preferences: '/preferences',
    balance: '/balance',
    login: '/login',
    welcomeLogin: '/welcome/login',
    welcomeTryIt: '/welcome/tryit',
    onboard: '/onboard',
    completeAccount: '/welcome/complete-account',
    chatQuickstart: '/chat/quickstart',
    examStart: '/exam',
    practiceStart: '/practice',
    schoolsCatalog: (learningLanguage: string, locale: string, cityName: string) => `/schools/${learningLanguage}/${locale.toLowerCase()}/${cityName}`,
};